import classNames from 'classnames';
import { h, JSX } from 'preact';

export interface LoaderProps {
    // If you want to animate opacity transition, render as hidden when not needed
    isHidden?: boolean;
}

export const Loader = ({ isHidden }: LoaderProps): JSX.Element => (
    <div class={classNames('kinola-loader', { 'kinola-loader--hidden': isHidden })}>
        <div class='kinola-loader__inner'>
            {[1, 2, 3, 4].map((i) => (
                <div key={i} class='kinola-loader__circle'></div>
            ))}
        </div>
    </div>
);
